import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter3() {
  const hyperlinkData = [
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/ontario/',
      copy: 'paddling through Ontario—like filmmaker Trevor Wallace',
      label: 'Visit Episode two, Explore Ontario with Trevor Wallace'
    },
    {
      href: 'https://www.rockymountaineer.com/',
      copy: 'Rocky Mountaineer',
      label: 'Visit Rocky Mountaineer Homepage'
    },
    {
      href: 'https://www.chateau-lake-louise.com/',
      copy: 'Fairmont Chateau Lake Louise',
      label: 'Visit Fairmont Chateau Lake Louise Homepage'
    },
    {
      href: 'https://jasperbrewingco.ca/',
      copy: 'Jasper Brewing Co',
      label: 'Visit Jasper Brewing Co Homepage'
    },
    {
      href: 'https://www.banffjaspercollection.com/attractions/banff-gondola/',
      copy: 'Banff Gondola',
      label: 'Visit Banff Gondola Official Page'
    },
    {
      href: 'https://mahikan.ca/',
      copy: 'Mahikan Trails',
      label: 'Visit Mahikan Trails Homepage'
    },
    {
      href: 'https://www.banff-springs-hotel.com/',
      copy: 'Fairmont Banff Springs',
      label: 'Visit Fairmont Banff Springs Homepage'
    }
  ];
  return (
    <section className="chapter">
      <h2 className="chapter__head">Jasper, Banff, and the Rocky Mountains</h2>
      <h3 className="chapter__subhead">Connecting to nature through adventure</h3>
      <p className="chapter__paragraph">
        The Canadian Rockies, one of the country’s most visited spots, straddle the provinces of
        British Columbia and Alberta. The town of Banff has been welcoming visitors since the 1880s,
        when sightseers gathered to see awe-inspiring Banff National Park—Canada’s designated
        first—in search of Alpine grandeur.
      </p>
      <p className="chapter__paragraph">
        Canada is a natural adventure destination. While{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} />
        —is one way to get your fix, it’s not the only place you can go. Take a road trip exploring
        picture-perfect peaks and turquoise lakes on the Icefields Parkway between Banff and Jasper,
        a gorgeous drive that’s stunning in both winter and summer months. During summertime, travel
        by rail in the luxury glass-domed <Hyperlink hyperlinkData={hyperlinkData[1]} />. Begin your
        multi-day rail journey from Vancouver and end at the{' '}
        <Hyperlink hyperlinkData={hyperlinkData[2]} /> resort—a playground for outdoor adventures
        like hiking, canoeing, and camping. Or head to Jasper, a laid-back mountain town with ample
        chances to spot bears, bighorn sheep, elk, and more. Hike Jasper National Park’s backcountry
        trails in peace, returning to town for bites and brews at{' '}
        <Hyperlink hyperlinkData={hyperlinkData[3]} />. Back in Banff, there’s more to explore
        year-round on the <Hyperlink hyperlinkData={hyperlinkData[4]} /> with its sweeping mountain
        views 7,500 feet up Sulphur Mountain. Once you come down, get to know the land you stand on
        with Brenda Holder, Indigenous tour operator and owner of{' '}
        <Hyperlink hyperlinkData={hyperlinkData[5]} />, who’ll take you on a healing medicine walk
        designed to honor the knowledge of her ancestors. Wind down at the{' '}
        <Hyperlink hyperlinkData={hyperlinkData[6]} /> resort, enjoying the mineral pools at
        Fairmont Spa, its unique restaurants, and inviting lounges and adventures offered by the
        resort experience team.
      </p>
    </section>
  );
}

export default Chapter3;
